<template>
  <div class="text-image-block max-w-7xl mx-auto py-10 mb-4 md:py-20 md:mb-10">
    <FormattedHeader :header="header" />
    <div
      class="flex flex-wrap justify-center"
      :class="index % 2 ? 'flex-row-reverse' : 'flex-row'"
    >
      <div class="text-block max-w-2xl p-8">
        <TypeDisplay
          :variant="$options.Typography.Display.MEGA"
          :weight="$options.Typography.Weights.STRONG"
          tag="p"
          class="text-title"
        >
          {{ title }}
        </TypeDisplay>
        <TypeBody
          :variant="$options.Typography.Body.LARGE"
          :weight="$options.Typography.Weights.REGULAR"
          class="body-text"
        >
          <span v-html="body" />
        </TypeBody>
        <BaseButton
          v-if="index === 2"
          size="large"
          class="block m-4 cta-button"
          @click="
            sendTo(
              `https://application.partnerstack.com/application?company=bambee&group=financialservices`
            )
          "
        >
          Become a Partner
        </BaseButton>
      </div>
      <div class="image-block p-8">
        <img :src="image" alt="image-block" class="image max-w-lg" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { BaseButton, TypeBody, TypeDisplay, constants } from '@bambeehr/pollen';
import FormattedHeader from '@/components/FormattedHeader.vue';

const { Typography } = constants;

export default defineComponent({
  name: 'TextImageBlock',
  Typography,
  components: { BaseButton, FormattedHeader, TypeBody, TypeDisplay },
  props: {
    header: { type: String, default: '' },
    title: { type: String, default: '' },
    body: { type: String, default: '' },
    image: { type: String, default: '' },
    index: { type: Number, required: true },
  },
  methods: {
    sendTo(path) {
      location.href = path;
    },
  },
});
</script>

<style scoped>
.body-text >>> li {
  @apply mb-4;
}
.cta-button {
  background-color: #2894c5 !important;
}
</style>
